module.exports = __webpack_public_path__ + "img/client.1ddc8211.png";